import type { Drill } from "./types";

type RecordedPractice = Pick<
  Drill["practices"][number],
  "id" | "createdAt" | "outcomes" | "successes" | "complete"
>;

export function drillPerformance(practices: readonly RecordedPractice[]) {
  return [...practices]
    .sort(
      (a, b) =>
        b.createdAt.localeCompare(a.createdAt) || b.id.localeCompare(a.id),
    )
    .slice(0, 20)
    .filter((practice) => practice.outcomes.length > 0)
    .reverse()
    .map((practice) => ({
      id: practice.id,
      createdAt: practice.createdAt,
      successes: practice.successes,
      attempts: practice.outcomes.length,
      complete: practice.complete,
      rate: (practice.successes / practice.outcomes.length) * 100,
    }));
}
